module.exports = __webpack_public_path__ + "static/media/5.4b3df6b8.jpg";